import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import CustomCursor from './CustomCursor';

const NotFound = () => {
  return (
    <div className="bg-black text-text-primary min-h-screen font-sans grainy">
      <CustomCursor />
      <div className="min-h-screen flex flex-col items-center justify-center text-center px-4">
        <motion.h1
          className="font-heading text-8xl md:text-9xl font-black text-text-primary"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          404
        </motion.h1>
        <motion.p
          className="font-mono text-lg md:text-xl text-text-secondary mt-2"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Error: Route not found in this workspace.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <Link
            to="/"
            className="inline-block mt-8 bg-accent text-text-primary font-bold py-3 px-8 rounded-lg hover:opacity-90 transition-opacity text-lg"
          >
            Return to Home
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;